// PHOENIX-959 (fase 5.1): o numero do cartao gravado chega do back mascarado - ************1234, ou
// MASCARA_CREDENCIAL quando o gravado nao tem cara de numero de cartao - e o back mantem o gravado quando o salvar
// devolve a mascara. Mesma regra do MascaraLogSigiloso.isMascarado do back: qualquer outra coisa e gravada como numero.
import { MASCARA_CREDENCIAL } from './credencialMascarada'

const NUMERO_COM_4_ULTIMOS = /^\*+\d{4}$/

export const isNumeroCartaoMascarado = (value) =>
  typeof value === 'string' && (value === MASCARA_CREDENCIAL || NUMERO_COM_4_ULTIMOS.test(value))

// Mascara do registro na tela: a que veio do back fica lembrada enquanto o operador digita, para apagar o que digitou
// (em qualquer foco) voltar a "nao trocou". Campo vazio vindo de fora (registro novo, outro registro) esquece.
export const lembrarMascara = (mascaraLembrada, value) => {
  if (isNumeroCartaoMascarado(value)) {
    return value
  }
  if (value === null || value === undefined || value === '') {
    return null
  }
  return mascaraLembrada
}

// Apagar tudo com o cartao gravado volta a mascara: o back mantem o numero. Limpar nao apaga o cartao gravado - no
// plano Vindi o numero e obrigatorio, e plano com outra forma de pagamento ja grava sem cartao.
export const valorAoDigitar = (texto, mascaraLembrada) => (texto === '' && mascaraLembrada ? mascaraLembrada : texto)

// Editando com a mascara: campo vazio para digitar o numero novo, sem editar a mascara como se fosse o numero.
export const valorExibido = (value, editando) => (editando && isNumeroCartaoMascarado(value) ? '' : value || '')
